/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

import { errorMessageOf } from 'hooks/useDocumentRequirements';
import { NewDocumentRequirementPayload } from 'services/actions/ai_management_document_requirements';

interface AiManagementAddRequirementPaneProps {
  onAdd: (requirement: NewDocumentRequirementPayload) => Promise<unknown>;
  onClose: () => void;
}

const AiManagementAddRequirementPane: React.FC<AiManagementAddRequirementPaneProps> = ({
  onAdd,
  onClose,
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [edictExcerpt, setEdictExcerpt] = useState('');
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!title.trim()) return;

    setSaving(true);
    setErrorMessage('');
    onAdd({
      title: title.trim(),
      description: description.trim() || undefined,
      edict_excerpt: edictExcerpt.trim() || undefined,
    })
      .then(onClose)
      .catch((err) => {
        setErrorMessage(errorMessageOf(err, 'Não foi possível adicionar a exigência.'));
        setSaving(false);
      });
  };

  return (
    <form className="d-flex flex-column h-100" onSubmit={handleSubmit}>
      <div className="flex-grow-1 overflow-auto p-4">
        <div className="d-flex align-items-start justify-content-between mb-3">
          <h4 className="mb-0">Adicionar nova exigência de documento</h4>
          <button type="button" className="close ml-3" aria-label="Fechar" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>

        <div className="form-group">
          <label htmlFor="requirement-documento">Nome do documento exigido</label>
          <input
            id="requirement-documento"
            className="form-control"
            placeholder="Ex.: Balanço Patrimonial"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="requirement-descricao">Descrição do tipo de documento</label>
          <input
            id="requirement-descricao"
            className="form-control"
            placeholder="Ex.: Atestado de capacidade técnico-operacional de locação de sistema informativo..."
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="requirement-trecho">Trecho do Edital que solicita o documento</label>
          <textarea
            id="requirement-trecho"
            className="form-control"
            rows={4}
            placeholder="Ex.: item 1.1 - Descrição do item aqui."
            value={edictExcerpt}
            onChange={(event) => setEdictExcerpt(event.target.value)}
          />
          <small className="form-text text-muted">
            Copie e cole o trecho do edital que exige o documento.
          </small>
        </div>

        {errorMessage && <div className="alert alert-danger mb-0">{errorMessage}</div>}
      </div>

      <div className="d-flex justify-content-end border-top p-3">
        <button type="submit" className="btn btn-primary" disabled={!title.trim() || saving}>
          {saving ? 'Adicionando...' : 'Adicionar exigência'}
        </button>
      </div>
    </form>
  );
};

export default AiManagementAddRequirementPane;
